export default class iCalLinkViewModel {
    public companyCalendar: string = '';
    public managerOfTeamCalendar: string | null = '';
    public memberOfTeamCalendar: string | null = '';
    public userCalendar: string | null = '';
}